// extracted by mini-css-extract-plugin
export default {"ns_button":"NSButton_ns_button__alexX","ns_button_disabled":"NSButton_ns_button_disabled__R46MG"};